import { render, staticRenderFns } from "./ModattaTable.vue?vue&type=template&id=12b517f4"
import script from "./ModattaTable.vue?vue&type=script&lang=js"
export * from "./ModattaTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports